import { render, staticRenderFns } from "./BuildingFolder.vue?vue&type=template&id=00175944&scoped=true&"
import script from "./BuildingFolder.vue?vue&type=script&lang=js&"
export * from "./BuildingFolder.vue?vue&type=script&lang=js&"
import style0 from "./BuildingFolder.vue?vue&type=style&index=0&id=00175944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00175944",
  null
  
)

export default component.exports